module.exports = __webpack_public_path__ + "static/img/esipenko.d94b577.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/esipenko.jpg
// module id = 469
// module chunks = 11